import { type InferGetServerSidePropsType, type NextPage } from "next";
import Link from "next/link";
import CategoryComponents from "~/components/CategoryComponents";
import GridLoop from "~/components/GridLoop";
import Layout from "~/components/Layout";
import Pagination, { usePagination } from "~/components/Pagination";
import { getMultimediaElemets } from "~/lib/db/multimedia";
import { ISSUES_TYPE, type ArticlePreviewType } from "~/types";

const DEFAULT_ITEMS_PER_PAGE = 18;

const Podcast: NextPage<InferGetServerSidePropsType<typeof getStaticProps>> = ({
  parent_category_slug,
  parent_category_description,
  articles,
  subCategory,
}) => {
  const articlessShow = usePagination(articles, DEFAULT_ITEMS_PER_PAGE);
  const displaySubcategories = subCategory.map((el, index) => {
    return {
      id: index,
      item: {
        term: el,
      },
    };
  });

  return (
    <Layout title="Podcast">
      <section
        className={`${subCategory.length > 0 ? "bg-green" : ""} -mt-12 w-full`}
      >
        <div className="mx-auto max-w-box px-4 pb-32 pt-24">
          <h3 className="mb-4 text-lg font-bold">
            <Link href={`/audio-bs`} className="font-bold text-white">
              Audio & podcast
            </Link>
          </h3>
          <div className="mb-20 lg:mb-32">
            <h1
              className={`${
                subCategory.length > 0 && "text-white"
              } text-4xl font-light md:text-6xl`}
            >
              Podcast
            </h1>
            {parent_category_description && (
              <p
                className={`${
                  subCategory.length > 0 &&
                  !parent_category_slug.includes("lo-studio") &&
                  "text-white"
                } mb-10 mt-10 text-lg font-medium md:mb-24`}
              >
                {parent_category_description}
              </p>
            )}
          </div>
          {displaySubcategories.length > 0 ? (
            <div className="grid items-start gap-24 md:grid-cols-2 lg:grid-cols-3">
              {displaySubcategories.map((item, index) => (
                <CategoryComponents
                  key={index}
                  data={item}
                  tax={ISSUES_TYPE.multimedia}
                />
              ))}
            </div>
          ) : (
            <GridLoop
              gridloop={articlessShow as ArticlePreviewType[]}
              categoria={"category"}
              imageShow={true}
            />
          )}
        </div>
      </section>
      <div
        className={`mx-auto mt-6 max-w-box px-4 text-center ${
          (subCategory.length > 0 && !parent_category_slug.includes("lo-studio")
            ? subCategory.length
            : articles.length) > DEFAULT_ITEMS_PER_PAGE
            ? ""
            : "hidden"
        }`}
      >
        <Pagination
          totalResults={
            subCategory.length > 0 &&
            !parent_category_slug.includes("lo-studio")
              ? subCategory.length
              : articles.length
          }
          itemsPerPage={DEFAULT_ITEMS_PER_PAGE}
        />
      </div>
    </Layout>
  );
};

export default Podcast;

export const getStaticProps = async () => {
  const podcast = await getMultimediaElemets("podcast");

  if (!podcast) return { notFound: true };

  return {
    props: {
      category_slug: podcast.category_slug,
      parent_category_slug: podcast.parent_category_slug,
      parent_category_name: podcast.parent_category_name,
      parent_category_description: podcast.parent_category_description ?? null,
      subCategory: podcast.subCategory,
      articles: podcast.articles,
    },
    //revalidate: 10 * 60,
  };
};
